import { render, staticRenderFns } from "./MlClassField.vue?vue&type=template&id=5110bd8e"
import script from "./MlClassField.vue?vue&type=script&lang=js"
export * from "./MlClassField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports